import type { OnboardingFormFields } from '@Types/index.ts';
export interface IReviewForm {
  [OnboardingFormFields.CHECKBOX_FINAL_AGREEMENT]: boolean;
  [OnboardingFormFields.CHECKBOX_EXCHANGE_INFO]: boolean;
  [OnboardingFormFields.CHECKBOX_BENEFICIAL_OWNERS]?: boolean;
}

export enum REVIEW_BLOCK_TYPES {
  CONTACT = 'Contact',
  PHONE = 'Phone',
  IDENTITY = 'Identity',
  HOME_ADDRESS = 'Home Address',
  BUSINESS_ADDRESS = 'Business Address',
  OPERATIONAL_ADDRESS = 'Operational Address',
  BUSINESS_DETAILS = 'Business Details',
  ACCOUNT_TYPE = 'Account Type',
  UBOS = 'UBOs',
  MAILING_ADDRESS = 'Mailing Address',
}
